import { createClient, SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    '[Supabase] Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. Admin portal will not function until these are set.'
  );
}

/** Tells AdminAuthContext when the server wants a fresh authenticator code. */
const fetchWithTwoStepNotice: typeof fetch = async (input, init) => {
  const res = await fetch(input, init);
  if (res.status === 401 || res.status === 403) {
    res.clone().json()
      .then((body: { hint?: string; error?: string } | null) => {
        if (body?.hint === 'two_step_required' || body?.error === 'two_step_required') {
          window.dispatchEvent(new Event('admin-two-step-required'));
        }
      })
      .catch(() => {});
  }
  return res;
};

export const supabase: SupabaseClient = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder-key',
  { global: { fetch: fetchWithTwoStepNotice } },
);
